import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { IAddProductRequest, IListName, IListShare, ILists, IOrchestratedListDetails, IOrchestratedLists } from '@shared/favorites/data-access/interfaces';

import { DCSG_CONSTANTS } from '@shared/data-access/constants';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/* istanbul ignore file */

@Injectable({
	providedIn: 'root'
})


export class WishListDao {

	constructor(private http: HttpClient) { }

	private readonly url = '/v1/mylocker';

	/** LIST APIs */

	/**
	 * @returns {Observable<any>}
	 *
	 * @description
	 * Function that calls the Favorites Engine deleteWishList API to delete the wish list.
	 * This coarse-grain API accepts listID as a parameter
	 *
	 * @param listId
	 */
	deleteWishlist(listID: string) {
		const httpParams = new HttpParams().set('listIDs',listID);
		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params:httpParams
		};

		return this.http.delete(`${this.url}/lists`, httpOptions);
	}

	/**
	 * @returns {Observable<ILists>}
	 *
	 * @description
	 * Function that calls the Favorites Engine getWishLists API to delete the wish list.
	 * This coarse-grain API accepts listID as a parameter
	 *
	 * @param listId
	 */
	getLists(brand: string, offset: number = null, limit: number = null): Observable<ILists> {
		let httpParams = new HttpParams().set('brand', brand.toUpperCase());

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};
		if (offset) {
			httpParams = httpParams.append('offset', offset);
		}
		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.get<ILists>(`${this.url}/lists`, httpOptions);
	}

	getOrchestratedLists(brand: string, offset: number = null, limit: number = null): Observable<IOrchestratedLists> {
		let httpParams = new HttpParams().set('brand', brand.toUpperCase());

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};
		if (offset) {
			httpParams = httpParams.append('offset', offset);
		}
		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.get<IOrchestratedLists>(`${this.url}/orchestration/lists`, httpOptions);
	}

	/**
	 * @returns {Observable<any>}
	 *
	 * @description
	 * Function that calls the Favorites Engine getWishlist API to get the details of a single wish list.
	 * This coarse-grain API accepts brandName, offset, limit, listID as a parameter
	 *
	 * @param brandName
	 * @param offset
	 * @param limit
	 * @param listId
	 */
	getListDetails(brand: string, listID: string, offset: number = null, limit: number = null) {

		let httpParams = new HttpParams().set('brand', brand.toUpperCase());

		if (offset) {
			httpParams = httpParams.append('offset', offset);
		}
		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}
		if (listID) {
			httpParams = httpParams.append('listID', listID);
		}

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.get(`${this.url}/lists/detail`, httpOptions);
	}

	//@description
	//* this is for sharing public version of the favorite list
	//* This API accepts brandName, offset, limit, listID as a parameter
	getPublicOrchestratedListDetails(accessToken: string, offset: number, limit: number) {

		let httpParams = new HttpParams().set('accessToken', accessToken);

		if (offset) {
			httpParams = httpParams.append('offset', offset);
		}
		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`,
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};
		
		return this.http.get(`${this.url}/orchestration/lists/detail/public`, httpOptions);
	}


	getOrchestratedListDetails(brand: string, listID: string, offset: number = null, limit: number = null): Observable<IOrchestratedListDetails> {
		let httpParams = new HttpParams().set('brand', brand.toUpperCase());

		if (offset) {
			httpParams = httpParams.append('offset', offset);
		}
		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}
		if (listID) {
			httpParams = httpParams.append('listID', listID);
		}

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.get<IOrchestratedListDetails>(`${this.url}/orchestration/lists/detail`, httpOptions);
	}

	getPublicListDetails(accessToken: string, offset: number, limit: number) {
		let httpParams = new HttpParams().set('accessToken', accessToken);


		if (offset) {
			httpParams = httpParams.append('offset', offset);
		}
		if (limit) {
			httpParams = httpParams.append('limit', limit);
		}

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.get(`${this.url}/lists/detail/public`, httpOptions);
	}

	generateShareLink(listID: string): Observable<IListShare> {
		const httpParams = new HttpParams().set('listID', listID);

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.put<IListShare>(`${this.url}/lists/share`, {}, httpOptions);
	}

		/**
	 *
	 *
	 * @description
	 * Function makes and API call check for available list names and filter out the prohibited names
	 *
	 * @param brand
	 * @param listName
	 * @returns [{id:string,defaultList:boolean,name:string}]
	 */

	createOrUpdateList(listName: IListName, listType: string, brand: string) {
		const httpParams = new HttpParams().set('brand', brand);

		if(listType) {
			httpParams.append('listType', listType);
		}

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};
		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams,
		};
		return this.http.put(`${this.url}/lists`, listName, httpOptions);

	}

	getRecommendedList(athleteID: string, brand: string): Observable<IOrchestratedListDetails> {
		const httpParams = new HttpParams().set('athleteID', athleteID).append('brand', brand.toUpperCase());

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams,
		};

		return this.http.get<IOrchestratedListDetails>(`${this.url}/orchestration/lists/recommendations`, httpOptions);
	}

	/** PRODUCT APIs */

	/**
	 * @returns {Observable<any>}
	 *
	 * @description
	 * Function that calls the Favorites Engine updateProductInformation API to update the product info of a list of products.
	 * This coarse-grain API accepts listID and products as a parameter
	 *
	 * @param listId
	 * @param products
	 */

	addProductToList(listID: string, products: IAddProductRequest, brand: string): Observable<any> {
		let httpParams = new HttpParams().set('brand', brand.toUpperCase());

		if (listID) {
			httpParams = httpParams.append('listID', listID);
		}

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};
		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};

		return this.http.put(`${this.url}/products`, products, httpOptions);
	}

	/**
	 * @returns {Observable<any>}
	 *
	 * @description
	 * Function that calls the Favorites Engine deleteProductInformation API to delete the product information of a list..
	 * This coarse-grain API accepts listID and productID as a parameter
	 *
	 * @param listId
	 * @param productID
	 */

	deleteProductInformation(productIds: string[]) {

		const httpParams = new HttpParams().set('productIds', productIds.join());

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};
		return this.http.delete(`${this.url}/products`, httpOptions);
	}

	getSavedItemsFromAllLists(ecode: string, brand: string): Observable<any> {
		const httpParams = new HttpParams().set('Ecode', ecode).set('brand', brand);
		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};
		return this.http.get<any>(`${this.url}/products/mapBySku`, httpOptions);
	}

	getFavoritedEcodes(brand: string): Observable<any> {
		const httpParams = new HttpParams().set('brand', brand);

		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};

		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams
		};
		return this.http.get<any>(`${this.url}/products/mapByEcode`, httpOptions);
	}



	// return the total count and current list count
	// takes chain as params


	getListCount(brand: string) {

		const httpParams = new HttpParams().set('brand', brand);
		const httpHeaders = {
			'Accept': 'application/json;',
			'Content-Type': 'application/json',
			'Access-Control-Allow-Origin': '*',
			'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
			'Pragma': 'no-cache',
			'X-TIMEOUT': `${DCSG_CONSTANTS.timeouts.xshort}`
		};
		const httpOptions = {
			headers: new HttpHeaders(httpHeaders),
			params: httpParams,
		};
		return this.http.get(`${this.url}/lists`, httpOptions);

	}

}
